import { editorClient } from "@/lib/editorClient";
import { notFound } from "@tanstack/react-router";

export async function getProjectLanguages(
  organizationSlug: string,
  projectSlug: string
) {
  const res = await editorClient.projects[":organizationSlug"][
    ":projectSlug"
  ].languages.$get({
    param: {
      organizationSlug,
      projectSlug,
    },
  });
  if (!res.ok) {
    if (res.status === 404) throw notFound();
    throw new Error("Failed to fetch project languages");
  }
  return await res.json();
}
